import React from 'react';
import { Button, Dropdown } from 'antd';
import { BgColorsOutlined } from '@ant-design/icons';

import { useTheme } from './ThemeProvider';

export default function ThemePicker() {
    const { themeKey, setThemeKey, themes } = useTheme();

    const items = Object.entries(themes).map(([key, t]) => ({
        key,
        label: t.name,
    }));

    return (
        <Dropdown
            menu={{
                items,
                selectable: true,
                selectedKeys: [themeKey],
                onClick: ({ key }) => setThemeKey(key),
            }}
            placement="bottomRight"
            trigger={['click']}
        >
            <Button type="text" icon={<BgColorsOutlined />} aria-label="Theme" />
        </Dropdown>
    );
}
